// extracted by mini-css-extract-plugin
module.exports = {"container":"ThemeSwitcher_container__2Vab0","on":"ThemeSwitcher_on__3HxmV","icon":"ThemeSwitcher_icon__gtmnI"};